export enum ModalDialogueHeight {
	HEIGHT_FLEX = 'HEIGHT_FLEX',
	HEIGHT_FIXED = 'HEIGHT_FIXED'
}
